<template>
  <div :class="b()">
    <div :class="b('headline')">
      <h3 :class="b('title')">
        <e-icon
          :class="b('filter-list-icon')"
          focusable="false"
          aria-hidden="true"
          icon="i-filter"
          size="24"
          inline
        />
        {{ $t('c-filter-state.title-selected-filters') }}
      </h3>
      <e-button
        v-if="showResetAll"
        :class="b('button-reset-all')"
        type="button"
        variant="text-underline"
        @click="onResetFilter"
      >
        {{ $t('c-filter-state.button-reset-all-filters') }}
      </e-button>
    </div>

    <ul :class="b('filter-list')">
      <template
        v-for="filterGroup in filterGroupsWithSelection"
        :key="filterGroup.fieldname"
      >
        <li :class="b('filter-item', { label: true })">{{ filterGroup.label }}:</li>
        <li
          v-for="filter in filterGroup.values"
          :key="filter.label"
          :class="b('filter-item')"
        >
          <button
            :class="b('filter-item-button')"
            type="button"
            @click="onRemoveFilter(filterGroup, filter)"
          >
            {{ filter.label }}
            <e-icon
              icon="i-close"
              size="10"
            />
          </button>
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import eButton from '@/elements/e-button.vue';
  import eIcon from '@/elements/e-icon.vue';
  import { getFilterGroupsWithSelection, resetAllFilters, resetFilterInFilterGroupList } from '@/helpers/filters';
  import { Filter, FilterGroup } from '@/types/filter';

  // type Setup = {};
  // type Data = {};

  /**
   * Renders a selection of active filters.
   */
  export default defineComponent({
    name: 'c-filter-state',
    components: {
      eButton,
      eIcon,
    },

    props: {
      /**
       * Expects filter groups.
       */
      filterGroups: {
        type: Object as PropType<FilterGroup[]>,
        required: true,
      },

      /**
       * Allows defining whether to show the reset all filters button.
       */
      showResetAll: {
        type: Boolean,
        default: true,
      },
    },
    emits: {
      updateFilter: (): boolean => true,
    },

    // setup(): Setup {},
    // data(): Data {
    //   return {};
    // },

    computed: {
      filterGroupsWithSelection(): FilterGroup[] {
        const { filterGroups } = this;

        return getFilterGroupsWithSelection(filterGroups);
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      onRemoveFilter(filterGroup: FilterGroup, filter: Filter): void {
        resetFilterInFilterGroupList(this.filterGroups, filterGroup, filter);

        this.$emit('updateFilter');
      },

      onResetFilter(): void {
        resetAllFilters(this.filterGroups);

        this.$emit('updateFilter');
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-filter-state {
    margin-bottom: 3rem;

    &__headline {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      margin-bottom: 2rem;
    }

    &__title {
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    &__filter-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.75rem 0.5rem;
    }

    &__filter-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem;

      &--label {
        font-size: variables.$font-size--smallest;
        font-weight: bold;
      }
    }

    &__filter-item-button {
      @include mixins.hover-effect--default;

      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: variables.$font-size--smallest;
      border-radius: 2.6rem;
      border: 1px solid var(--theme-color-grayscale--500);
      padding: 0.15rem 0.65rem;
      cursor: pointer;
    }

    &__button-reset-all {
      font-size: variables.$font-size--small;
      text-decoration: underline;
    }
  }
</style>
